import * as svg from "../../../assets/airbnb-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const AirbnbIcon = iconBuilder(svg, "AirbnbIcon", "0 0 900 900");
